export default __webpack_public_path__ + "f6832694b0741a5ffc7997d7d4d4b2c4.jpg";